import {
  catchError,
  isParseObject,
  useSource,
  useTranslation,
} from "@opendash/core";
import { Icon } from "@opendash/icons";
import { Source } from "@opendash/plugin-parse/dist/types-generated";
import { Table, Tag, Typography } from "antd";
import { ColumnsType } from "antd/lib/table";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React, { useEffect, useState } from "react";
import { ItemSelectType } from "..";
import {
  Schedule_Execution,
  Schedule_Execution_Step,
  Schedule_Template,
  SourceMeta,
} from "../../../js/parsegenerated";
import { Schedule_Step } from "../../../js/parsegenerated/Schedule_Step";

export const StepsTable = observer(
  (props: {
    schedule: Schedule_Template | Schedule_Execution | undefined;
    showAddButton?: boolean;
  }) => {
    const t = useTranslation();
    const [steps, setSteps] = useState<
      Schedule_Step[] | Schedule_Execution_Step[]
    >([]);
    const [reload, setReload] = useState<number>(0);
    const [source] = useSource();
    const [items, setItems] = useState<Array<ItemSelectType>>([]);
    const [columns, setColumns] = useState<ColumnsType<any>>([]);

    function getDescription(record: Schedule_Step | Schedule_Execution_Step) {
      if (isParseObject(record, Schedule_Step.className)) {
        const obj = record as Schedule_Step;
        return (
          <span>
            {obj.get("title")}{" "}
            {obj.get("description") !== undefined
              ? " - " + obj.get("description")
              : null}
          </span>
        );
      }

      if (isParseObject(record, Schedule_Execution_Step.className)) {
        const obj = record as Schedule_Execution_Step;
        return (
          <span>
            {obj.get("title")}{" "}
            {obj.get("description") !== undefined
              ? " - " + obj.get("description")
              : null}
          </span>
        );
      }

      return <span></span>;
    }

    function getDone(record: Schedule_Step | Schedule_Execution_Step): boolean {
      if (isParseObject(record, Schedule_Step.className)) {
        false;
      }

      if (isParseObject(record, Schedule_Execution_Step.className)) {
        return (record as Schedule_Execution_Step).done;
      }

      return false;
    }

    function getRowKey(
      record: Schedule_Step | Schedule_Execution_Step
    ): string {
      if (
        isParseObject(record, Schedule_Step.className) ||
        isParseObject(record, Schedule_Execution_Step.className)
      ) {
        return record.id;
      }

      return crypto.randomUUID();
    }

    useEffect(() => {
      new Parse.Query(SourceMeta)
        .equalTo("source", {
          className: Source.className,
          __type: "Pointer",
          objectId: source.id,
        })
        .include("item")
        .find()
        .then((sourcemetas) => {
          const itemoptions = sourcemetas.map((sourcemeta) => {
            return {
              value: sourcemeta.get("item").id,
              label: sourcemeta.get("item").get("name"),
              key: sourcemeta.get("item").id,
            };
          });
          setItems(itemoptions);
        });
    }, []);

    useEffect(() => {
      const tmpcolumns: ColumnsType<any> = [];

      if (isParseObject(props.schedule, Schedule_Execution.className)) {
        tmpcolumns.push({
          title: t("maintenance:schedule.table.columns.done.label"),
          key: "done",
          dataIndex: "done",
          render: (_, record: Schedule_Step | Schedule_Execution_Step) => (
            <span>
              {getDone(record) === true ? (
                <Tag color="success" icon={<Icon icon="fa:check" />}>
                  {t("maintenance:global.yes")}
                </Tag>
              ) : (
                <Tag color="warning" icon={<Icon icon="fa:times" />}>
                  {t("maintenance:global.no")}
                </Tag>
              )}
            </span>
          ),
        });
      }
      tmpcolumns.push({
        title: t("maintenance:schedule.table.columns.description.label"),
        key: "description",
        dataIndex: "description",
        render: (_, record: Schedule_Step | Schedule_Execution_Step) =>
          getDescription(record),
      });

      setColumns(tmpcolumns);
    }, [props.schedule]);

    useEffect(() => {
      async function fetch() {
        if (
          props.schedule !== undefined &&
          props.schedule.className === Schedule_Template.className
        ) {
          const [queriedstepsError, queriedsteps] = await catchError(
            (props.schedule as Schedule_Template).steps.query().find()
          );
          setSteps(queriedsteps);
        }

        if (
          props.schedule !== undefined &&
          props.schedule.className === Schedule_Execution.className
        ) {
          const [resulterror, result] = await catchError(
            new Parse.Query(Schedule_Execution_Step)
              .equalTo(
                "scheduleexecution",
                props.schedule as Schedule_Execution
              )
              .find()
          );

          if (resulterror) {
            return;
          }

          const mapresult = result.map(
            async (step): Promise<Schedule_Execution_Step> => {
              const [mediaerror, media] = await catchError(
                step.relation("media").query().find()
              );

              const [roleserror, roles] = await catchError(
                step.relation("roles").query().find()
              );

              if (mediaerror || roleserror) {
                return step;
              }

              step.relation("media").add(media);
              step.relation("roles").add(roles);

              return step;
            }
          );

          const steps = await Promise.all(mapresult);

          setSteps(steps);
        }
      }

      fetch();
    }, [props.schedule, reload]);

    return (
      <>
        <Typography.Title level={4}>
          {t("maintenance:schedule.step.steps.headline")}
        </Typography.Title>
        <Table
          rowKey={(record: Schedule_Step | Schedule_Execution_Step) =>
            getRowKey(record)
          }
          size="middle"
          columns={columns}
          dataSource={steps}
          style={{ marginTop: 20, marginBottom: 20 }}
          pagination={false}
        />
      </>
    );
  }
);
